export const en = {
    preparation: "Loading"
};
